import { useState } from "react";

/** "Preview" tab content — large render plus 3 multi-size thumbnails. */
export function PreviewPanel({ svg }: { svg: string }) {
  const [size, setSize] = useState<128 | 256 | 512>(256);
  return (
    <>
      <div className="section-label">Preview</div>
      <div className="preview-stack">
        <div className="preview-large" dangerouslySetInnerHTML={{ __html: svg }} />
        <div className="preview-row">
          {[128, 256, 512].map((sz) => (
            <button key={sz} className={`chip ${size === sz ? "active" : ""}`} onClick={() => setSize(sz as 128 | 256 | 512)}>
              {sz}px
            </button>
          ))}
        </div>
        <div className="preview-thumb-row">
          <div className="preview-thumb" style={{ width: size, height: size }} dangerouslySetInnerHTML={{ __html: svg }} />
        </div>
      </div>
    </>
  );
}
